module.exports = "transactions tells us that money was transferred from one place to another. understanding how money flows is the first step in getting a grip on what happens financially. <ui-view/> ";


//////////////////
// WEBPACK FOOTER
// .-dna/app/crud/clerk-ledger/steps/transactions.html
// module id = 2516
// module chunks = 86